import { LayoutDashboard, BarChart3, User, FileText, Trophy, BookOpen } from 'lucide-react';
import { handleTabKeyDown } from '../utils/tabKeyboard';

const TAB_ICONS = {
  home: LayoutDashboard,
  recap: FileText,
  playoffs: Trophy,
  stats: BarChart3,
  team: User,
  history: BookOpen,
};

const SHORT = { home: 'Home', team: 'Team' };

export function BottomBar({ tabs, activeTab, onTabChange }) {
  return (
    <nav
      role="tablist"
      aria-label="Dashboard sections"
      className="sm:hidden flex ledger-scope"
      style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 20,
        height: '58px',
        background: 'var(--ledger-panel)',
        borderTop: '1px solid var(--ledger-line)',
      }}
    >
      {tabs.map(tab => {
        const Icon = TAB_ICONS[tab.id] || LayoutDashboard;
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            id={`dashboard-tab-mobile-${tab.id}`}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-controls="dashboard-panel"
            tabIndex={isActive ? 0 : -1}
            onClick={() => onTabChange(tab.id)}
            onKeyDown={e => handleTabKeyDown(e, tabs.map(t => t.id), activeTab, onTabChange, id => `dashboard-tab-mobile-${id}`)}
            style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center', gap: '3px',
              background: 'none', border: 'none', cursor: 'pointer',
              color: isActive ? 'var(--ledger-ink)' : 'var(--ledger-muted)',
              boxShadow: isActive ? 'inset 0 2px 0 var(--ledger-ink)' : 'none',
            }}
          >
            <span style={{ position: 'relative', display: 'flex' }}>
              <Icon aria-hidden="true" style={{ width: '16px', height: '16px' }} />
              {tab.dot && (
                <span aria-hidden="true" style={{ position: 'absolute', top: '-3px', right: '-5px', width: '7px', height: '7px', borderRadius: '50%', background: 'var(--you)', border: '1px solid var(--ledger-panel)' }} />
              )}
            </span>
            <span style={{ fontSize: '11px', fontWeight: isActive ? 600 : 500 }}>
              {SHORT[tab.id] ?? tab.label}
              {tab.dot && <span className="sr-only">, new</span>}
            </span>
          </button>
        );
      })}
    </nav>
  );
}

export default BottomBar;
